import { Base, Component, Emit, Prop, Ref } from '@/vue-property-decorator'
import { Bind, Throttle } from '@/utils/Decorator'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import AppTypes from '@/vue-types'
import MyScroll, {
  MyScrollEvents,
  ScrollPosition
} from '@/components/my-scroll'
import style from './style.module.scss'

interface Props {
  /**卡片个数，翻页使用 */
  cardCounts: number
  /** 卡片宽度，即步长，要严格按网格的宽度给定 */
  stepWidth: number
  /** 卡片容器的显示宽度 */
  containerWidth: number
  /** 是否展示分页 */
  isPageNation?: boolean
}
interface Slots {
  title?: BaseRenderContent
  default?: BaseRenderContent
  buttonPrev?: void
  buttonNext?: void
}
@Component<ScrollPagination>({
  name: 'ScrollPagination'
})
export default class ScrollPagination extends Base<
  unknown,
  Props,
  MyScrollEvents,
  Slots
> {
  /**滚动位置在起点 */
  private atStart = true
  /**滚动位置在终点 */
  private atEnd = false
  /**滚动条宽度 */
  private scrollWidth = 0
  /**滚动条水平位置 */
  private scrollLeft = 0

  @Prop(AppTypes.number.def(6))
  private readonly cardCounts!: Props['cardCounts']

  @Prop(AppTypes.number.def(1))
  private readonly stepWidth!: Props['stepWidth']

  @Prop(AppTypes.number.def(0))
  private readonly containerWidth!: Props['containerWidth']

  @Prop(AppTypes.bool.def(true))
  private readonly isPageNation!: Props['isPageNation']

  @Ref()
  private readonly myscrollRef!: MyScroll

  @Bind()
  @Throttle(300)
  private scrollChange(position: ScrollPosition) {
    this.scrollWidth = position.scrollWidth
    this.scrollLeft = position.x
    this.setStatEndStatus(position.x)
  }

  get isWeb() {
    return useMainStore().isWeb
  }
  /**
   * 翻页操作
   * @param direction 翻页方向是否为向右
   */
  private scrollPageTo(direction: 'right' | 'left') {
    if (!this.containerWidth || !this.stepWidth) return
    const stepWidth = this.stepWidth * this.cardCounts
    let x = 0

    // 向右，如滚动到最后，直接使用 scrollWidth
    if (direction === 'right') {
      x = this.scrollLeft + stepWidth
      x = x > this.scrollWidth ? this.scrollWidth : x
    } else {
      // 向左，如滚动到开头，直接使用 0
      x = this.scrollLeft - stepWidth
      x = x < 0 ? 0 : x
    }
    this.myscrollRef?.scrollTo({ x: x })
  }
  /**
   * 设置翻页箭头按钮可用状态
   * @param x 当前滚动条位置
   */
  private setStatEndStatus(x: number) {
    this.atEnd = x >= this.scrollWidth - this.stepWidth * this.cardCounts
    this.atStart = x <= 0
  }

  /**
   * 点击全部事件
   */
  @Emit('handleAll')
  private onHandleAll(e: Event) {
    return e
  }

  render() {
    const { t } = useI18n()
    return (
      <section class={[style.scrollPagination, 'scroll-pagination']}>
        <div class="head">
          <div class="leftTitle">{this.$slots.title}</div>
          {this.isPageNation && (
            <div class="stakeController">
              <div
                class={['toLeft', this.atStart ? 'isLeft' : '']}
                onClick={() => this.scrollPageTo('left')}
              >
                {this.$slots.buttonPrev || this.$scopedSlots.buttonPrev || (
                  <icon-sprite sprite={createSvgSprite('comm_icon_jt')} />
                )}
              </div>
              <div class="total" onClick={this.onHandleAll}>
                {t('lobby.game.loadingAll')}
              </div>
              <div
                class={['toRight', this.atEnd ? 'isRight' : '']}
                onClick={() => this.scrollPageTo('right')}
              >
                {this.$slots.buttonNext || this.$scopedSlots.buttonNext || (
                  <icon-sprite sprite={createSvgSprite('comm_icon_jt')} />
                )}
              </div>
            </div>
          )}
        </div>

        {this.isPageNation ? (
          <my-scroll
            ref="myscrollRef"
            direction="x"
            dragable={true}
            stepWidth={this.stepWidth}
            trigger="none"
            onScrollChange={this.scrollChange}
          >
            <div class="gameListWrap">{this.$slots.default}</div>
          </my-scroll>
        ) : (
          <div class="gameListWrap">{this.$slots.default}</div>
        )}
      </section>
    )
  }
}
